<template>
<div>
    <Breadcrumbs main="CRM" title="Sales Representative" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Representative</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <b-row class="d-flex justify-content-center align-items-center">
                                    <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                        <b-input-group style="width: 340px;">
                                            <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>

                                        <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectConnected || selectedLabel">
                                            <feather type="x"></feather>
                                            <h7>Clear All</h7>
                                        </div>
                                    </b-col>

                                    <b-col xl="6">
                                        <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                            <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-8">
                                <div class="client-container" style="margin-top: 22px;">
                                    <div class="table-width">
                                        <div v-if="!loading && !error">
                                            <div class="table-responsive datatable-vue">
                                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered" style="overflow-x: scroll;">
                                                    <template #cell(index)="data">
                                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                                    </template>

                                                    <template #cell(name)="data">
                                                        <div v-if="data.item.full_name" style="display: flex; flex-direction: column;">
                                                            <h7><span style="font-weight: 500;">{{ data.item.full_name }}</span></h7>
                                                            <a :href="`mailto:${data.item.email}`">
                                                                <small> {{ data.item.email }}</small>
                                                            </a>
                                                        </div>
                                                    </template>

                                                 

                                                    <template #cell(territory)="data">
                                                        <div v-if="data.item.territory">
                                                            <small>{{ data.item.territory }}</small>
                                                        </div>
                                                        
                                                    </template>

                                                    <template #cell(action)="data">
                                                        <span style="display: flex; gap: 12px;">
                                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletecompany(data.item.id)" title="Delete"></feather>
                                                            <feather @click="editItem(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                        </span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="loader-box">
                                                <div class="loader-10"></div>
                                            </div>
                                        </div>

                                        <b-col class="my-1 p-0">
                                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                                        </b-col>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-4">

                                <div class="d-flex flex-wrap" style="gap: 12px;">
                                    <div class="mini-box">
                                        <p class="mini-label">Representatives</p>
                                        <h7 class="mini-value">{{ count }}</h7>
                                    </div>
                                    <!-- <div class="mini-box">
                                        <p class="mini-label">Healthy Accounts</p>
                                        <h7 class="mini-value">75</h7>
                                    </div>
                                    <div class="mini-box">
                                        <p class="mini-label">At Risk</p>
                                        <h7 class="mini-value">25</h7>
                                    </div> -->

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Sales Representative Create -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Create Sales Representative" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="User" label-for="user-name">
                <b-form-select id="user-name" v-model="rep.user" :options="userOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Employee
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Team Name" label-for="team-name">
                <b-form-select id="team-name" v-model="rep.team" :options="teamOptions" >
                        <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Team
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Territory" label-for="territory-name">
                <b-form-select id="territory-name" v-model="rep.territory" :options="territoryOptions" >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Territory
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>

            
           

        </form>
    </b-modal>

    <!-- Edit Representative -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Sales Representative" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <b-form-group label="User" label-for="user-name">
                <b-form-select id="user-name" v-model="edit_rep.user" :options="userOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Employee
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Team Name" label-for="team-name">
                <b-form-select id="team-name" v-model="edit_rep.team" :options="teamOptions" >
                        <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Team
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Territory" label-for="territory-name">
                <b-form-select id="territory-name" v-model="edit_rep.territory" :options="territoryOptions" >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Territory
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this representative?</div>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name'
                },
                {
                    key: 'team',
                    label: 'Team'
                },
                {
                    key: 'territory',
                    label: 'Territory'
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            rep: {
                user: null,
                team: null,
                territory: null,

            },
            nameState: null,
            edit_rep: {
                id: '',
                user: null,
                team: null,
                territory: null,
            },

            delete_value: null,

            filter: null,

            filterShow: false,
            selectConnected: '',
            selectedLabel: null,

            initialLoad: true,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

            teamOptions: [{
                    id: 1,
                    value: 'Team A',
                    text: 'Team A'
                },
                {
                    id: 2,
                    value: 'Team B',
                    text: 'Team B'
                },
                {
                    id: 3,
                    value: 'Team C',
                    text: 'Team C',
                }
            ],

        };
    },

    computed: {
        ...mapState({
            items: state => state.salesRep.salesRep_paginated,
            count: state => state.salesRep.salesRep_count,
            loading: state => state.salesRep.submitLoading,
            error: state => state.salesRep.submitError,
          

            territories: state => state.territory.territory,
            user_list: state => state.employee.employee_list,

        }),
        userOptions() {
            return this.user_list.map(user => ({
                value: user.id,
                text: `${user.first_name} ${user.last_name} - ( ${user.additional_info?.department?.name || ''} | ${user.additional_info?.designation?.title || ''} )`
            }));
        },
        territoryOptions(){
            return this.territories.map(territory => ({
                value: territory.id,
                text: territory.name
            }));
        }




    },

    mounted() {
        this.$store.dispatch("territory/fetchTerritory")
        this.$store.dispatch("employee/fetchEmployeeList");

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }
    },

    watch: {
        assignedLabels: {
            handler: function (newVal, oldVal) {
                this.storeAssignedLabels(newVal);
            },
            deep: true
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("salesRep/fetchSalesRepPaginated", {
                    perPage: this.perPage,
                    currentPage: 1,
                    search_term: this.filter,

                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/crm/sales-representative/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("salesRep/fetchSalesRepPaginated", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/crm/sales-representative/list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("salesRep/fetchSalesRepPaginated", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    methods: {
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        fetchInitial() {
            this.$store.dispatch("salesRep/fetchSalesRepPaginated", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,

            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        clearFilter() {
            this.filterShow = false,
                this.filter = null

        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {

            this.rep.user = null
            this.rep.team = null
            this.rep.territory = null
           

        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("salesRep/addSalesRep", {
                salesRep: this.rep,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })

        },

        editItem(item) {

            this.edit_rep.id = item ?.id
            this.edit_rep.team = item ?.team
            this.edit_rep.territory = item ?.territory
            this.edit_rep.user = item ?.user?.id
       
        },

        resetEditModal() {
            this.edit_rep.id = null
            this.edit_rep.user = null
            this.edit_rep.team = null
            this.edit_rep.territory = null
        },

        handleEditSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("salesRep/updateSalesRep", {
                id: this.edit_rep.id,
                salesRep: this.edit_rep,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })

        },

        deletecompany(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("salesRep/deleteSalesRep", {
                item: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

    }
};
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.mini-box {
    flex: 0 0 200px;
    width: 200px;
    padding: 16px 24px;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

}

.mini-box:hover {
    transform: translateY(-3px);
}

.mini-label {
    font-size: 14px;
    font-weight: 600;
    color: #62748e;
}

.mini-value {
    font-size: 18px;
    font-weight: 700;

}
</style>
